let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cWASZ")).then(() => parcelRequire('2CO28'));